import { render, staticRenderFns } from "./UnknownQuestionsDialog.vue?vue&type=template&id=0c9a63ba&scoped=true"
import script from "./UnknownQuestionsDialog.vue?vue&type=script&lang=js"
export * from "./UnknownQuestionsDialog.vue?vue&type=script&lang=js"
import style0 from "./UnknownQuestionsDialog.vue?vue&type=style&index=0&id=0c9a63ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9a63ba",
  null
  
)

export default component.exports